const mutations = {
  // 登录凭证
  sessionId(state, status) {
    state.sessionId = status
  },
}

export default mutations



// WEBPACK FOOTER //
// ./src/vue/vuex/mutations.js